module.exports = __webpack_public_path__ + "img/tuhuang.01b9d9a1.png";